
import { Users, Building, ChartBar } from "lucide-react";
import { useCountAnimation } from "@/hooks/use-count-animation";

const MetricsSection = () => {
  const clients = useCountAnimation({ end: 100000 });
  const clinics = useCountAnimation({ end: 7200 });
  const transactions = useCountAnimation({ end: 350 });

  const formatNumber = (num: number) => {
    if (num >= 1000) {
      return `${(num / 1000).toLocaleString('pt-BR', { maximumFractionDigits: 0 })}k`;
    }
    return num.toLocaleString('pt-BR');
  };

  return (
    <section className="section-padding bg-gradient-to-br from-drcash-maastricht-blue to-drcash-sapphire-blue text-white">
      <div className="container mx-auto px-4 md:px-8">
        <h2 className="text-3xl md:text-4xl font-bold mb-12 text-center">
          Números que nos orgulham
        </h2>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div className="text-center" ref={clients.elementRef}>
            <Users className="w-12 h-12 mx-auto mb-4 text-drcash-caribbean-green" />
            <div className="text-4xl font-bold mb-2">+{formatNumber(clients.count)}</div>
            <p className="text-gray-300">Clientes atendidos</p>
          </div>

          <div className="text-center" ref={clinics.elementRef}>
            <Building className="w-12 h-12 mx-auto mb-4 text-drcash-caribbean-green" />
            <div className="text-4xl font-bold mb-2">+{formatNumber(clinics.count)}</div>
            <p className="text-gray-300">Clínicas parceiras</p>
          </div>

          <div className="text-center" ref={transactions.elementRef}>
            <ChartBar className="w-12 h-12 mx-auto mb-4 text-drcash-caribbean-green" />
            <div className="text-4xl font-bold mb-2">R$ {formatNumber(transactions.count)}M+</div>
            <p className="text-gray-300">Em transações processadas</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MetricsSection;
